module.exports = __webpack_public_path__ + "static/elephantmummymain-ce528d1ba9c0728b0e8eb9f0615c45b7.png";